<template>
    <div id="app">
    <home-pc v-if="isPc()"></home-pc>
    <home-mobile v-else></home-mobile>
  </div>
</template>

<script>
import TopSection from './components/TopSection'
import HomePc from './components/HomePc'
import HomeMobile from './components/HomeMobile'

export default {
  name: 'app',
  components: {
    TopSection,
    HomePc,
    HomeMobile
  },
  methods: {
    isPc(){
      return screen.width > 800 ? true: false;
    }
  }
}
</script>

<style>
html{
  background-color: black;
}
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: Microsoft YaHei, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// App.vue?6475cc80